import { Parameter } from "domain/entities/parameter";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface TripDestinationState {
  tripDestination: Parameter[];
  setTripDestination: (newTripDestination: Parameter[] | undefined) => void;
}

export const useTripDestinationStore = create<TripDestinationState>()(
  devtools(
    (set) => ({
      tripDestination: [],
      setTripDestination: (newTripDestination) =>
        set(() => ({
          tripDestination: newTripDestination ? [...newTripDestination] : [],
        })),
    }),
    { name: "TripDestinationStore" }
  )
);
